// extracted by mini-css-extract-plugin
module.exports = {"container":"AZymKR","button":"_1UD7Jx","icon":"_1hrJCG"};